
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/grade-summary/jst/outcome';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.addMasteryIcon || (depth0 && depth0.addMasteryIcon),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.status), options) : helperMissing.call(depth0, "addMasteryIcon", (depth0 && depth0.status), options)))
    + "\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "\n    <i aria-hidden=\"true\" class=\"icon-empty\"></i>\n  ";
  }

function program5(depth0,data) {
  
  var stack1, helper;
  if (helper = helpers.hover_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.hover_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  return escapeExpression(stack1);
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <span class=\"screenreader-only\">\n          ";
  if (helper = helpers.hover_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.hover_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </span>\n      ";
  return buffer;
  }

  buffer += "<div class=\"outcome-icon ";
  if (helper = helpers.status) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.status); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-tooltip=\"top\" title=\"";
  if (helper = helpers.statusTooltip) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.statusTooltip); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <span class=\"screenreader-only\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'statusTooltip': ((depth0 && depth0.statusTooltip)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("grade_summary.outcome")
  },data:data},helper ? helper.call(depth0, "outcome_title_has_a_status_of_statustooltip_82d1e6d9", "Outcome: %{title} has a status of %{statusTooltip}", options) : helperMissing.call(depth0, "t", "outcome_title_has_a_status_of_statustooltip_82d1e6d9", "Outcome: %{title} has a status of %{statusTooltip}", options)))
    + "\n  </span>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.scoreDefined), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<div class=\"outcome-properties\">\n  <div class=\"title\" data-tooltip title=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hover_name), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n    <h4>\n      ";
  if (helper = helpers.friendly_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.friendly_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hover_name), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </h4>\n  </div>\n  <div class=\"description\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n</div>\n<div class=\"alignment-info\">\n  <a href=\"#tab-outcomes/";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" role=\"button\" aria-haspopup='true' aria-controls='outcome_detail'>\n    ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.count), options) : helperMissing.call(depth0, "n", (depth0 && depth0.count), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_count': (stack1),
    'w0': ("<strong>$1</strong>"),
    'i18n_inferred_key': (true),
    'i18n_scope': ("grade_summary.outcome")
  },data:data},helper ? helper.call(depth0, "n_count_alignments_a45bebe7", "*%{n_count}* Alignments", options) : helperMissing.call(depth0, "t", "n_count_alignments_a45bebe7", "*%{n_count}* Alignments", options)))
    + "\n  </a>\n  <a class=\"more-details\"\n    href=\"#\"\n    role=\"button\"\n    tabindex=\"0\">\n    <i class=\"icon-more\" role=\"presentation\"></i>\n    <span class=\"screenreader-only\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("grade_summary.outcome")
  },data:data},helper ? helper.call(depth0, "click_for_more_details_on_this_outcome_8c018d2f", "click for more details on this outcome", options) : helperMissing.call(depth0, "t", "click_for_more_details_on_this_outcome_8c018d2f", "click for more details on this outcome", options)))
    + "\n    </span>\n  </a>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  